module.exports = __webpack_public_path__ + "static/media/saba-sport.5f9c524d.webp";